/*
 *******************************************************************************
 * 
 *  Filename:   ./agents/agentGoCampaign_Counties.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Agent for GoCampaign County API endpoints.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Saturday, October 26, 2019 - 03:25:47 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      10/26/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { requests } from './requests';

export const GoCampaign_Counties = {
    all: (countryid, stateid) => requests.get(`/GoCampaignCounties?countryid=${countryid}&stateid=${stateid}`),
    get: gocampaigncountyid => requests.get(`/GoCampaignCounty/${gocampaigncountyid}`),
    create: gocampaigncounty => requests.post(`/GoCampaignCounties`, gocampaigncounty),
    update: (gocampaigncountyid, gocampaigncounty) => requests.put(`/GoCampaignCounty/${gocampaigncountyid}`, gocampaigncounty),
    delete: gocampaigncountyid => requests.del(`/GoCampaignCounty/${gocampaigncountyid}`),
};


// WEBPACK FOOTER //
// ./src/agents/agentGoCampaign_Counties.js